import Lock from './Lock.es6'
import {doAjax, iff, switchf, disable, htmlToNode} from './lib.es6';

/* global _env */
/**
 * _env {
 *   url: string サイトURL（トップレベル）
 *   project: string プロジェクト識別コード（プロジェクトディレクトリ名）
 *   pos: boolean 位置情報をチェックするか否か？ trueの場合にチェックする
 *   period: number 使用制限期間(ミリ秒) マイナスの場合は制限をかけない
 *   time: number 演出実行時間
 *   nonce: string Nonce
 *   mode: string 初期モード指定
 *   use_thanks: boolean thanksページに遷移するか否か？ trueの場合に遷移する
 * }
 *
 */
/* global ga */

// 新しいカスタムイベントを作成
const sendPinEvent = new Event('sendPinEvent');
const finishEvent  = new Event('finishEvent');
const errorEvent  = new Event('errorEvent');

export default class Common {

	mode;
	lat;
	lng;

	constructor() {

		const period = iff( _env.period ).then( () => _env.period ).else( () => 600000 );

		/**
		 * ロック時間設定と操作履歴をもとに、操作ロックを判定する
		 */
		Lock( period )
			.then( () => {
				this.setEvent();
				this.getButtonStatus();
			})
			.catch( () => {
				this.lockOut( period )
			});

		this.disableHistoryBack();

	}

	setEvent(){

		document.addEventListener('click', (event) => {
			if (event.target.classList.contains('p-button__send')) {
				const code = event.target.dataset.id;
				if ( ! code ) return;

				this.sendCode( code );

			}

			if (event.target.classList.contains('p-modal__close')) {

				const title = document.getElementById( 'modal_title' );
				if ( title ) {
					title.innerText = '';
				}

				const contents = document.getElementById( 'modal_contents' );
				if ( contents ) {
					contents.innerText = '';
				}

				document.documentElement.dataset.mode = 'error';
			}

		} );
	}

	/**
	 * ブラウザバックを無効化する
	 * 履歴に現ページを追加し、ブラウザバックを検出したら、履歴を先に進める
	 */
	disableHistoryBack(){

		// 履歴に現ページを追加する
		history.pushState(null, null, location.href);
		// ブラウザバックを検出.
		window.addEventListener('popstate', (e) => {
			// History.go() メソッドは、セッション履歴から特定のページを読み込みます。
			// これを用いると、引数の値に応じて履歴の中を前方や後方に移動することができます。
			// 正の値は履歴を先に進める、負の値は戻す。
			history.go(1);
		});

	}

	/*****************************
	 * sendCode
	 * @param code
	 * return void
	 *****************************/
	sendCode ( code )
	{

		console.log( 'sendCode', code );
		this.mode = document.documentElement.dataset.mode;
		document.documentElement.dataset.mode = 'doing_ajax';

		doAjax(
			'set_code',
			{ code },
			( data ) => {

				// dispatchEvent()を使用してカスタムイベントをトリガー
				document.dispatchEvent(sendPinEvent);

				setTimeout( () => {
					// dispatchEvent()を使用してカスタムイベントをトリガー
					document.dispatchEvent(finishEvent);
					document.documentElement.dataset.mode = _env.mode;
				}, _env.time )

				if ( typeof ga != 'undefined' ){
					ga('send', 'event', 'send_code', code, data.dev, data.pin );
				}
			},
			( data ) => {
				this.failAction( data );
				if (typeof ga != "undefined"){
					ga('send', 'event', 'send_fail', code, data.dev, data.pin );
				}
			},
		)
		.then( () => {
		});
	}

	/*****************************
	 * setTemplate
	 * @param obj
	 * return void
	 *****************************/
	setTemplate( obj ) {

		this.mode = document.documentElement.dataset.mode;
		document.documentElement.dataset.mode = 'modal';

		const modal = document.getElementById( 'modal' );
		const title = document.getElementById( 'modal_title' );
		const contents = document.getElementById( 'modal_contents' );
		if ( modal && title && contents ) {
			title.innerHTML = obj.title;
			contents.innerHTML = obj.contents;
		}

	}

	getCurrentPos() {

		return new Promise( ( resolve, reject ) => {

			const options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			};

			navigator.geolocation.getCurrentPosition(
				( pos ) => {
					const crd  = pos.coords;
					doAjax(
						"get_button_status",
						{
							'geo_code': {
								'lat':crd.latitude,
								'lng':crd.longitude,
							}
						},
						( data ) => {
							resolve();
						},
						() => {
							reject( { title: '位置エラー', contents: '現在の位置ではサービスをご利用頂けません' } );
						}
					).then();

				},
				( err ) => {
					reject( { title: '測位エラー', contents: '現在位置が取得できませんでした' } );
				},
				options
			);
		} );
	}

	failAction( data ) {

		const message = switchf( data.code )
			.case( -1 ).then( () => { return "JSONパースエラー"; } )
			.case( -2 ).then( () => { return "JSONフォーマットエラー"; } )
			.case( -3 ).then( () => { return "keyエラー"; } )
			.case( -4 ).then( () => { return "pinエラー"; } )
			.case( -5 ).then( () => { return data.data; } )
			.default( () => { return "不正なコードが返却されました"; } );

		this.setTemplate( { title: "通信エラー", contents: message } );

		// dispatchEvent()を使用してカスタムイベントをトリガー
		document.dispatchEvent(errorEvent);

	}

	getDeviceStatus()	{

		document.documentElement.dataset.mode = 'preload';

		const button = document.getElementsByTagName( 'button' );

		doAjax(
			"get_status",
			{},
			( data ) => {
				disable( button, false );

				/*******************************************************************
				 * 	data.data: {
				 * 		"device": {
				 * 			"device_id"       : "abcdefgh",
				 * 			"name"            : "名前",
				 * 			"product_name"    : "IoT コネクタ",
				 * 			"product_version" : "v1.0.0",
				 * 			"alive_flg"       : false,
				 * 			"revoke_flg"      : false,
				 * 			"connected_at"    : null,
				 * 			"disconnected_at" : "2017 -01 -31 12:00:00"
				 * 		}
				 * 	}
				 ********************************************************************/

				if ( _env.pos === 1 ) {
					this.getCurrentPos()
						.then( () => {
							this.setTimer();
						} )
						.catch( ( err ) => {
							this.setTemplate( err );
						});
				} else {
					this.setTimer();
				}


			},
			( data ) => {
				disable( button, true );
				this.failAction( data );
			}
		)
		.then( () => {

		});

	}

	getButtonStatus()
	{

		const button = document.getElementsByTagName( 'button' );

		this.mode = document.documentElement.dataset.mode;
		document.documentElement.dataset.mode = 'preload';

		doAjax(
			"get_button_status",
			{},
			( data ) => {
				let flag = false;
				/*******************************************************************
				 * 	data.data: {
				 * 		"btn_id": bool, ...
				 * 	}
				 ********************************************************************/
				for ( const btn_id in data.data ) {

					if ( data.data[btn_id] ) {
						flag = true;
					} else {
						const target = document.getElementById( btn_id );
						if ( target ) {
							disable( target, true );
						}
					}

				}

				if( flag ){
					if ( _env.pos === 1 ) {
						this.getCurrentPos()
							.then( () => {
								this.setTimer();
							} )
							.catch( ( err ) => {
								this.setTemplate( err );
							});
					} else {
						this.setTimer();
					}
				} else {
					this.setTemplate( { title: 'デバイスエラー', contents: 'IoTデバイスから返信がありません' } );
				}

			},
			( data ) => {
				disable( button, true );
				this.failAction( data );
			}
		)
		.then( () => {
		} );

	}

	/**
	 * setLock
	 * 使用した履歴をタイムスタンプのミリ秒で記録
	 * Void
	 */
	setLock() {

		localStorage.setItem( `illumination_lock_${_env.project}`, Date.now().toString() );

	}

	/**
	 * lockOut
	 * @param period Number ロックする時間（マイクロ秒）
	 */
	lockOut( period ) {

		const min = period / 60000;
		this.setTemplate( { "title": "連続してご利用いただけません", "contents": `前回のご利用時間から${min}分以上経過していないため、ご利用頂けません。` } );

		const button = document.getElementsByTagName( 'button' );
		disable( button, true );

	}

	/**
	 * タイムアウトでページ転送
	 */
	setTimer() {

		document.documentElement.dataset.mode = _env.mode;
		const timeout = iff( _env.timeout ).then( () => _env.timeout ).else( () => 60000 );
		if( timeout > 0 ){
			setTimeout(
				() => {

					if ( _env.period > 0 ) {
						this.setLock();
					}

					if ( _env.url && _env.project && _env.use_thanks ) {
						location.replace( `${_env.url}/${_env.project}/thanks/` );
					} else {
						document.dispatchEvent(finishEvent);
						document.documentElement.dataset.mode = _env.mode;
					}
				},
				timeout
			);
		}
	}

}
